import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProactiveSupportRoute: InvariantJiraRoute = {
	name: 'servicedesk-proactive-support',
	path: '/jira/servicedesk/projects/:projectKey/proactive-support',
	exact: true,
};
